import React from 'react';
import Chatbot from './components/Chatbot';

function App() {
  return (
    <div className="App">
      <Chatbot />
    </div>
  );
}

export default App;
